(function () {
  function init(el) {
    if (el.__infSlider) return;
    el.__infSlider = true;

    var track = el.querySelector('[data-slider-track]');
    if (!track || track.children.length === 0) return;

    var pxPerSec = parseFloat(el.getAttribute('data-speed')) || 0;
    var dir = el.getAttribute('data-direction') === 'right' ? -1 : 1;

    var dragging = false, hovering = false, moved = false, axis = null;
    var startX = 0, startY = 0, startScroll = 0, last = null;

    function half() { return track.scrollWidth / 2; }

    function wrap() {
      var h = half();
      if (h <= 0) return;
      if (el.scrollLeft >= h) el.scrollLeft -= h;
      else if (el.scrollLeft <= 0) el.scrollLeft += h;
    }

    // Position inside the first copy so there is room to drag both ways.
    requestAnimationFrame(function () { el.scrollLeft = half() / 2; });

    function frame(t) {
      if (last === null) last = t;
      var dt = (t - last) / 1000;
      last = t;
      if (pxPerSec > 0 && !dragging && !hovering) {
        el.scrollLeft += pxPerSec * dir * dt;
        wrap();
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    el.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false; axis = null;
      startX = e.clientX; startY = e.clientY; startScroll = el.scrollLeft;
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (axis === null) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x') {
            el.classList.add('is-dragging');
            try { el.setPointerCapture(e.pointerId); } catch (err) {}
          }
        } else { return; }
      }
      if (axis === 'y') { dragging = false; return; } // let the page scroll
      moved = true;
      el.scrollLeft = startScroll - dx;
      wrap();
    });

    function up() { dragging = false; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);

    el.addEventListener('mouseenter', function () { hovering = true; });
    el.addEventListener('mouseleave', function () { hovering = false; });

    // Keep the loop seamless during native (trackpad/touch) scrolling too.
    el.addEventListener('scroll', function () { if (!dragging) wrap(); }, { passive: true });

    // Swallow the click that ends a drag so it doesn't trigger links/controls.
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-infinite-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
